import { render, staticRenderFns } from "./GoodsSummary.vue?vue&type=template&id=2968a65f"
import script from "./GoodsSummary.vue?vue&type=script&lang=js"
export * from "./GoodsSummary.vue?vue&type=script&lang=js"
import style0 from "./GoodsSummary.vue?vue&type=style&index=0&id=2968a65f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports